import React from 'react';
import { FiPlay, FiPause } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const LatestEpisodeHero = ({ episode, isPlaying, onPlay }) => {
  if (!episode) return null;

  // Fallback-bild om ingen bild finns i kalkylarket
  const episodeImage = episode.image || "https://images.unsplash.com/photo-1478737270239-2fccd27ee8fb?w=800&auto=format&fit=crop";

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 to-black text-white p-8 md:p-12 mb-12 shadow-2xl"
    >
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-30 md:opacity-40 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-l from-black via-black/50 to-transparent z-10"></div>
        <img 
          src={episodeImage} 
          alt={episode.title} 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-2xl">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#F28423] text-xs font-bold uppercase tracking-wider mb-6">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          Senaste avsnittet
        </div>
        
        <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
          {episode.title}
        </h2>
        
        <p className="text-gray-300 text-lg mb-8 line-clamp-2 md:line-clamp-3">
          {episode.description}
        </p>

        <button
          onClick={() => onPlay(episode)}
          className="flex items-center gap-3 bg-[#F28423] hover:bg-orange-600 text-white px-8 py-4 rounded-full font-bold transition-all transform hover:scale-105 active:scale-95 shadow-xl"
        >
          <SafeIcon icon={isPlaying ? FiPause : FiPlay} className="w-6 h-6" />
          <span>{isPlaying ? 'Pausa lyssning' : 'Lyssna nu'}</span>
        </button>
      </div>
    </motion.div>
  );
};

export default LatestEpisodeHero;